<template>
  <div class="Home">
    <header>
      <span>欢迎登录</span>
      <span @click="LoginOut">退出</span>
      <span class="iconfont icon-loginOut" @click="LoginOut"></span>
    </header>
    <div class="info">
      <div class="left">
        <img src="../assets/pic.png" alt="" />
      </div>
      <div class="right">
        <span v-text="'游客:' + userInfo.tel"></span>
        <span
          >欢迎登录苏州旅游团队电子行程单服务平台，您可以在此对行程进行监督与投诉。</span
        >
      </div>
    </div>
    <div class="main">
      <div class="mainScroll">
        <mt-loadmore
          :top-method="LoadTop"
          :bottomDistance="60"
          :bottom-method="LoadBottom"
          :bottom-all-loaded="allLoaded"
          ref="loadmore"
        >
          <div class="list" id="mainList">
            <div class="item" v-for="item in dataList" :id="item.Id">
              <div class="top" @click="GoTripDetail('TripDetail', item.Id, item.SignTime,item.OrderId)">
                <span class="iconfont icon-tripCorp"></span>
                <span v-text="item.Company"></span>
                <span
                  v-bind:class="{
                    doing: item.Status == 0,
                    group: item.Status == 1,
                    wait: item.Status == 2,
                    complete: item.Status >= 3
                  }"
                  v-text="GetStatus(item.Status)"
                ></span>
              </div>
              <div
                v-bind:class="{
                  center: true,
                  cdoing: item.Status == 0,
                  cgroup: item.Status == 1,
                  cwait: item.Status == 2,
                  ccomplete: item.Status >= 3
                }"
                @click="GoTripDetail('TripDetail', item.Id, item.SignTime,item.OrderId)"
              >
                <span v-text="item.TripName"></span>
                <span v-text="'游玩天数：' + item.TripDays + '（天）'"></span>
                <span
                  v-text="'游玩人数：' + item.TrousitCount + '（人）'"
                ></span>
                <span v-text="'备案时间：' + item.PostTime"></span>
                <span v-text="'结束时间：' + item.EndTime"></span>
              </div>
              <div style="display:flex;">
                <div class="bottom" v-show="item.SignTime != null" @click="LookContact(item.OrderId)">查看合同</div>
                <div class="bottom" style="flex:1; text-align:right;">
                <span
                  v-text="item.SignTime != null ? '已签约' : '未签约'"
                ></span>
                <span
                  @click="GoScore('Score', item.Id)"
                  v-if="item.Id != null && item.Status == 3"
                  >我要评分</span
                >
                <a href="tel:12345">我要投诉</a>
              </div>
              </div>
              
            </div>
          </div>
        </mt-loadmore>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      userInfo: this.$common.userInfo,
      allLoaded: true,
      dataList: [],
      param: {
        pageIndex: 0,
        pageSize: 10,
        totalPage: 0
      },
      scrollTop: 0
    };
  },
  methods: {
     LookContact(orderId){
          var _self=this;
          _self.$router.push({
              name: "Econtact",  
              params: {
              orderId: orderId
              }
          });
      },
    GoTripDetail(url, Id, SignTime,OrderId) {
      let _self = this;

      if (SignTime == null) {
        _self.$router.push({
          name: "MainContact",
          params: {
            orderId: OrderId
          }
        });
        
        return;
      }

      if (Id == null) {
        _self.$messagebox({
          title: "提示",
          message: "暂未组团无法查看行程详情"
        });
      } else {
        _self.scrollTop = document.getElementById("mainList").offsetTop;
        sessionStorage.setItem("Vue_param", JSON.stringify(_self.param));
        sessionStorage.setItem("Vue_Top", _self.scrollTop);
        sessionStorage.setItem("Vue_TripId", Id);
        _self.$router.isBack = true;
        _self.$router.push({
          name: url,
          params: {
            tripId: Id
          }
        });
      }
    },
    GoScore(url, Id) {
      let _self = this;
      _self.scrollTop = document.getElementById("mainList").offsetTop;
      sessionStorage.setItem("Vue_param", JSON.stringify(_self.param));
      sessionStorage.setItem("Vue_Top", _self.scrollTop);
      sessionStorage.setItem("Vue_TripId", Id);
      _self.$router.isBack = true;
      _self.$router.push({
        name: url,
        params: {
          tripId: Id
        }
      });
    },
    LoginOut() {
      let _self = this;
      _self.$root.LoginOut();
    },
    LoadTop() {
      let _self = this;
      if (_self.param.pageIndex * 1 - 1 < 1) {
        _self.param.pageIndex = 1;
        _self.dataList = [];
      } else {
        _self.param.pageIndex = _self.param.pageIndex * 1 - 1;
      }

      _self.axios.all([_self.GetData(_self.param)]).then(
        _self.axios.spread(function(res) {
          //请求现在都执行完成
          _self.allLoaded = true; // 若数据已全部获取完毕
          _self.$refs.loadmore.onTopLoaded();
          _self.allLoaded = false;
        })
      );
    },
    LoadBottom() {
      let _self = this;
      if (_self.param.pageIndex * 1 + 1 <= _self.param.totalPage * 1) {
        _self.param.pageIndex = _self.param.pageIndex * 1 + 1;
        _self.axios.all([_self.GetData(_self.param)]).then(
          _self.axios.spread(function(res) {
            //请求现在都执行完成
            _self.allLoaded = true; // 若数据已全部获取完毕
            _self.$refs.loadmore.onBottomLoaded();
            _self.allLoaded = false;
          })
        );
      } else {
        _self.allLoaded = true; // 若数据已全部获取完毕
        setTimeout(() => {
          _self.$refs.loadmore.onBottomLoaded();
          _self.allLoaded = false;
        }, 0);
      }
    },
    GetData(param) {
      let _self = this;
      _self.axios
        .post("/api/tourist/Itineraries/GetItineraries", param)
        .then(res => {
          document.getElementById("mainList").scrollTop = 0;
          _self.dataList = res.data;
          _self.param.pageIndex = res.pageIndex;
          _self.param.pageSize = res.pageSize;
          _self.param.totalPage = res.totalPage;
        })
        .catch(err => {});
    },
    GetStatus(obj) {
      let _self = this;
      return _self.$status.GetItinerariesStatus(obj);
    }
  },
  created() {},
  mounted() {},
  activated() {
    let _self = this;

    if (!_self.$route.meta.isBack) {
      _self.GetData(_self.param);
    } else {
      if (_self.dataList == 0) {
        _self.param = JSON.parse(sessionStorage.getItem("Vue_param"));
        _self.axios.all([_self.GetData(_self.param)]).then(
          _self.axios.spread(function(res) {
            //请求现在都执行完成
            document.getElementById(
              "mainList"
            ).scrollTop = sessionStorage.getItem("Vue_Top");
          })
        );
      } else {
        document.getElementById("mainList").scrollTop = _self.scrollTop;
      }

      // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    }
    _self.$route.meta.isBack = false;
    sessionStorage.removeItem("Vue_param");
    sessionStorage.removeItem("Vue_Top");

    _self.axios
      .post("/api/tourist/Itineraries/RemindSignContact")
      .then(res => {
        if (res.data != null) {
          _self
            .$messagebox({
              title: "提示",
              message: "您有一份旅游电子合同待签，<br>请立即前往",
              showCancelButton: true,
              closeOnClickModal: false
            })
            .then(r => {
              if (r == "confirm") {
                _self.$router.push({
                  name: "MainContact",   //Econtact
                  params: {
                    orderId: res.data
                  }
                });
              }
            });
        }
      })
      .catch(err => {});
  }
};
</script>
<style lang="less" scoped>
.Home {
  width: 100%;
  min-height: 100%;
  background-image: url("../assets/home-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;

  box-sizing: border-box;
  background-color: #ddd;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  header {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    font-size: 24px;
    letter-spacing: 2px;
    color: #ffffff;
    align-items: center;

    span:nth-of-type(1) {
      flex: 1;
    }
    span:nth-of-type(2) {
      flex-shrink: 0;
      margin-right: 5px;
    }
    span:nth-of-type(3) {
      font-size: 24px !important;
    }
  }

  .info {
    padding: 0 20px;
    box-sizing: border-box;
    margin-top: 30px;
    width: 100%;
    display: flex;
    align-items: stretch;

    .left {
      width: 25%;
      flex-shrink: 0;
      margin-right: 30px;
      img {
        height: 100%;
        width: 100%;
        border-radius: 100%;
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;

      span:nth-of-type(1) {
        flex: 1;
        font-size: 36px;
        letter-spacing: 3px;
        color: #ffffff;
        display: flex;
        align-items: center;
      }
      span:nth-of-type(2) {
        flex: 1;
        font-size: 24px;
        letter-spacing: 2px;
        color: #ffffff;
        display: flex;
        align-items: center;
        word-break: break-all;
      }
    }
  }

  .main {
    flex: 1;
    width: 100%;
    position: relative;

    .mainScroll {
      padding: 5px 20px;
      box-sizing: border-box;
      position: absolute;
      top: 20px;
      bottom: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      width: 100%;
      overflow-y: auto;

      .list {
        width: 100%;
        height: 100%;
        .item {
          margin-bottom: 30px;
          background-color: #ffffff;
          box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.35);
          border-radius: 10px;
          display: flex;
          flex-direction: column;

          .top {
            padding: 20px;
            box-sizing: border-box;
            font-size: 24px;
            display: flex;
            align-items: center;

            span:nth-of-type(1) {
              color: #167fef;
              font-size: 24px !important;
              flex-shrink: 0;
              margin-right: 10px;
            }
            span:nth-of-type(2) {
              flex: 1;
              margin-right: 50px;
              color: #465865;
            }
            span:nth-of-type(3) {
              letter-spacing: 2px;
            }
            .wait {
              color: #ef9a44;
            }
            .group {
              color: #6aa564;
            }
            .doing {
              color: #35b0fd;
            }

            .complete {
              color: #666666;
            }
          }

          .center {
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            span:nth-of-type(1) {
              width: 100%;
              font-size: 36px;
              font-weight: bold;
              letter-spacing: 3px;

              margin-bottom: 30px;
              box-sizing: border-box;
            }

            span:nth-of-type(n + 2) {
              width: 50%;
              font-size: 24px;
              letter-spacing: 2px;
            }

            span:nth-of-type(-n + 3) {
              margin-bottom: 25px;
            }
          }
          .cdoing {
            background-color: #e6f6ff !important;
            color: #35b0fd !important;
          }
          .cgroup {
            background-color: #f1f8ef !important;
            color: #6aa564 !important;
          }
          .cwait {
            background-color: #fff6e8 !important;
            color: #ef9a44 !important;
          }
          .ccomplete {
            background-color: #f4f4f4 !important;
            color: #666666 !important;
          }
          .bottom {
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-size: 26px;
            letter-spacing: 2px;
            color: #167fef;
            justify-content: flex-end;

            span {
              margin-left: 50px;
            }

            a,
            a:link,
            a:visited,
            a:hover,
            a:active {
              color: #167fef !important;
              text-decoration: none;
              -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
              -webkit-user-select: none;
              -moz-user-focus: none;
              -moz-user-select: none;
              margin-left: 50px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue